<template>
  <!-- Chatbox -->
  <div
    class="chatbox-container"
    :class="{ open: chatOpen, glow: newMessagesReceived }"
  >
    <div @click="toggleChat" id="close-chatbox"></div>
    <div class="chatbox-header" @click="toggleChat">
      <button class="toggle-button">
        {{
          newMessagesReceived > 0 ? newMessagesReceived : chatOpen ? '>' : '<'
        }}
      </button>
    </div>
    <div class="chatbox-content">
      <div class="chatbox-messages" v-if="chatOpen" ref="chatboxMessages">
        <div
          v-for="(message, index) in chatMessages"
          :key="index"
          class="message"
        >
          <strong>{{ message.user }}:</strong> {{ message.text }}
        </div>
      </div>
      <div v-if="chatOpen" class="chatbox-input">
        <input
          v-model="newMessage"
          @keyup.enter="sendMessage"
          placeholder="Type a message..."
        />
        <button @click="sendMessage">Send</button>
      </div>
    </div>
  </div>
</template>

<script>
import { SocketManager } from '@/utility/SocketManager.js'

export default {
  name: 'ChatBox',
  inject: ['socket'],
  props: {
    roomId: String,
    userName: String,
  },
  data() {
    return {
      socketManager: null,
      chatOpen: false,
      newMessage: '',
      chatMessages: [],
      newMessagesReceived: 0,
    }
  },
  methods: {
    toggleChat() {
      this.chatOpen = !this.chatOpen

      if (this.chatOpen) {
        this.newMessagesReceived = 0
      }
    },
    sendMessage() {
      if (this.newMessage.trim() === '') return
      this.socketManager.emitSocketEvent('chatMessage', {
        roomId: this.roomId,
        userName: this.userName,
        newMessage: this.newMessage,
      })
      this.newMessage = '' // Clear input after sending
    },
  },
  watch: {
    chatMessages: {
      handler(newVal) {
        console.log('chatMessages updated:', newVal)
        this.$nextTick(() => {
          const chatBox = this.$refs.chatboxMessages
          if (chatBox) {
            chatBox.scrollTop = chatBox.scrollHeight
          }
        })
      },
      deep: true,
    },
    chatOpen(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const chatBox = this.$refs.chatboxMessages
          if (chatBox) {
            chatBox.scrollTop = chatBox.scrollHeight
          }
        })
      }
    },
  },
  mounted() {
    this.socketManager = new SocketManager(this.socket)

    // Listen for incoming chat messages from server
    this.socketManager.onSocketEvent('chatMessage', (user, text) => {
      this.chatMessages.push({ user, text })

      // Trigger glow effect only if chat is closed
      if (!this.chatOpen) {
        this.newMessagesReceived += 1
      }
    })
  },
  beforeUnmount() {
    this.socketManager.offSocketEvent('chatMessage')
  },
}
</script>

<style scoped>
.chatbox-container {
  height: 100%;
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0px;
  right: 0px;
  color: white;
  border-radius: 8px 0 0 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, opacity 0.3s ease;
  z-index: 300;
  overflow: hidden;
}

/* Closed State */
.chatbox-container:not(.open) {
  transform: translateX(20rem);
  opacity: 0.9;
}

/* Chatbox Header */
.chatbox-header {
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #333;
  padding: 8px 12px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  font-weight: bold;
}

/* Open State */
.chatbox-container.open {
  opacity: 1;
  z-index: 12;
  width: 100vw;
  display: flex;
  justify-content: flex-end;
}

#close-chatbox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

/* Messages */
.chatbox-messages {
  height: auto;
  overflow-y: auto;
  padding: 10px;
  font-size: 0.9rem;
  background: #222;
}

/* Chat Input */
.chatbox-input {
  display: flex;
  padding: 6px;
  border-top: 1px solid #444;
  background: #222;
  align-content: stretch;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
}

.chatbox-input input {
  flex: 1;
  margin-left: 6px;
  padding: 6px;
  border: none;
  border-radius: 4px;
  background: #333;
  color: white;
  outline: none;
}

.chatbox-input button {
  margin-left: 6px;
  background: #28a745;
  color: white;
  border: none;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 4px;
  font-weight: bold;
}

.chatbox-input button:hover {
  background: #218838;
}

.chatbox-content {
  z-index: 2;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 20rem;
  justify-content: flex-end;
  background: rgba(0, 0, 0, 0.85);
}

/* Toggle Button */
.toggle-button {
  all: unset; /* Remove all styles */
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
}
</style>